import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.css']
})
export class SpinnerComponent implements OnInit {
  @Input() color: string;
  @Input() width : string;
  @Input() height : string;

  constructor(private elementRef: ElementRef<HTMLElement>) { }

  ngOnInit(): void {
    this.color = this.color || getComputedStyle(document.documentElement).getPropertyValue('--first-ecommerce-color');
    this.width = this.width || '100px';
    this.height = this.height || '100px';

    this.elementRef.nativeElement.style.setProperty('--color', this.color);
    this.elementRef.nativeElement.style.setProperty('--width', this.width);
    this.elementRef.nativeElement.style.setProperty('--height', this.height);
  }
}
